import { useFormikContext } from "formik";
import React, { useEffect, useState } from "react";

import { Address, Forms, Grid, Modals } from "components";
import { countries, occupations } from "utils";

import { Divider } from "components";

import { useDebounce } from "hooks/debounce";
import * as S from "../../styles";
import { assets, incomes, relationship_degree } from "../../utils";

export const Individual = () => {
  const { values, errors, setFieldValue } = useFormikContext<{
    address: {
      city: string;
      state: string;
      number: string;
      street: string;
      zipcode: string;
      complement: string;
      neighborhood: string;
    };
    foreigner: {
      enabled: boolean;
      country: string;
    };
    pep: {
      enabled: boolean;
      relation: {
        enabled: boolean;
        degree: string;
      };
    };
  }>();

  const [zipcode, setZipcode] = useState("");
  const debouncedZipcode = useDebounce(zipcode);

  const getAddress = async () => {
    const address: any = await Modals.Address({
      zipcode: debouncedZipcode,
    });

    if (!address) return;

    for (const [key, value] of Object.entries(address)) {
      setFieldValue(`address.${key}`, value);
    }
  };

  useEffect(() => {
    if (debouncedZipcode && !errors.address?.zipcode) getAddress();
  }, [debouncedZipcode]); // eslint-disable-line

  return (
    <>
      <Grid columns={["auto", "repeat(2, 1fr)"]} gap={[".5rem", "1rem"]}>
        <Forms.InputGroup
          name="name"
          label="Nome"
          placeholder="Digite o nome"
        />

        <Forms.InputGroup
          name="birthdate"
          label="Data de nascimento"
          placeholder="Digite o data de nascimento"
          mask="date"
        />

        <Forms.InputGroup
          name="phone"
          label="Telefone/celular"
          placeholder="Digite o telefone/celular"
          mask="phone"
        />

        <Forms.InputGroup
          name="email"
          label="E-mail"
          placeholder="Digite o e-mail"
        />
      </Grid>

      <Divider title="Renda e documento extra" />

      <Grid columns={["auto", "repeat(2, 1fr)"]} gap={[".5rem", "1rem"]}>
        <Forms.SelectGroup
          name="occupation"
          label="Profissão"
          options={[
            {
              label: "Selecione a profissão",
              value: "",
            },
            ...occupations.map(({ description }) => ({
              label: description,
              value: description,
            })),
            {
              label: "Outros",
              value: "0",
            },
          ]}
        />

        <Forms.SelectGroup
          name="incomes"
          label="Renda mensal"
          options={incomes}
        />

        <Forms.SelectGroup
          name="net_equity"
          label="Patrimônio"
          options={assets}
        />
      </Grid>

      <Divider title="Dados complementares" />

      <Grid gap={[".5rem", "1rem"]}>
        <S.ChoiceWrapper>
          <Forms.Toggle label="Estrangeiro" name="foreigner.enabled" />

          <Forms.Toggle
            label="Pessoa exposta politicamente"
            name="pep.enabled"
          />

          <Forms.Toggle
            label="Grau de relacionamento com a PEP"
            name="pep.relation.enabled"
          />
        </S.ChoiceWrapper>
      </Grid>

      {(values.foreigner.enabled || values.pep.relation.enabled) && (
        <>
          <Grid
            columns={["auto", "repeat(2, 1fr)"]}
            space={["1rem 0 0", "2rem 0 0"]}
            gap={[".5rem", "1rem"]}
          >
            {values.foreigner.enabled && (
              <Forms.SelectGroup
                name="foreigner.country"
                label="País de residência"
                options={[
                  {
                    label: "Selecione o país de residência",
                    value: "",
                  },
                  ...countries.map(({ name }) => ({
                    label: name,
                    value: name,
                  })),
                ]}
              />
            )}

            {values.pep.relation.enabled && (
              <Forms.SelectGroup
                name="pep.relation.degree"
                label="Grau de relacionamento"
                options={relationship_degree}
              />
            )}
          </Grid>
        </>
      )}

      <Divider title="Endereço" />

      <Grid columns={["auto", "repeat(2, 1fr)"]} gap={[".5rem", "1rem"]}>
        <Forms.InputGroup
          name="address.zipcode"
          label="CEP"
          placeholder="Digite o CEP"
          mask="zipcode"
          onKeyUp={(event) => {
            setZipcode(event.target.value);
          }}
        />
      </Grid>

      <Grid space={[".5rem 0 0", "1rem 0 0"]}>
        <Address {...values.address} />
      </Grid>
    </>
  );
};
